<template>
    <video
        v-if="autoplayVideo?.url"
        ref="video"
        pip="false"
        preload="none"
        muted
        no-controls
        loop
        :src="getMediaLink(autoplayVideo.url) || undefined"
        class="aspect-video w-full rounded-20 object-cover" />
</template>

<script setup lang="ts">
import { useIntersectionObserver } from '@vueuse/core'
import type { Video } from '~/types/global.types'

defineProps({
    autoplayVideo: {
        type: Object as PropType<Video>,
        required: true,
    },
})

const video = ref<HTMLVideoElement | null>(null)

useIntersectionObserver(video, ([entry]) => {
    if (!video.value) return

    video.value.muted = true
    video.value.playsInline = true

    if (entry.isIntersecting) {
        video.value?.load()
        video.value?.play()
    } else {
        video.value?.pause()
        video.value?.load()
    }
})
</script>
